export default "__VITE_ASSET__Pu9DTmh9__"